import { FC } from "react";
import { Box } from "@mui/material";
import { Routes, Route } from "react-router-dom";
import { NewTC } from "./counterparties/newCounterparty";
import { CounterpartiesRoutes } from "./routes";
import { RequireCreateCounterparty } from "../../auth/RequireCreateCounterparty";

type Props = {};

export const TradingCounterparties: FC<Props> = () => {
  return (
    <Box
      display="flex"
      position="absolute"
      top={0}
      right={0}
      bottom={0}
      left={0}
      padding={2}
    >
      <CounterpartiesRoutes />
      <Routes>
        <Route
          path="new"
          element={
            <RequireCreateCounterparty>
              <NewTC />
            </RequireCreateCounterparty>
          }
        />
      </Routes>
    </Box>
  );
};
